/** 採購單狀態（契約 8 態，含 TERMINATED 中止；未知態 label／badge 不炸）。 */

export const PURCHASE_ORDER_STATUS = {
  DRAFT: 'DRAFT',
  SUBMITTED: 'SUBMITTED',
  APPROVED: 'APPROVED',
  PARTIALLY_RECEIVED: 'PARTIALLY_RECEIVED',
  RECEIVED: 'RECEIVED',
  CLOSED: 'CLOSED',
  TERMINATED: 'TERMINATED',
  CANCELLED: 'CANCELLED',
};

export const PURCHASE_ORDER_STATUS_LABELS = {
  DRAFT: '草稿',
  SUBMITTED: '已提交',
  APPROVED: '已核准',
  PARTIALLY_RECEIVED: '部分入庫',
  RECEIVED: '已入庫',
  CLOSED: '已結案',
  TERMINATED: '已中止',
  CANCELLED: '已取消',
};

export const PURCHASE_ORDER_STATUS_FILTER_OPTIONS = [
  { value: 'DRAFT', label: '草稿' },
  { value: 'SUBMITTED', label: '已提交' },
  { value: 'APPROVED', label: '已核准' },
  { value: 'PARTIALLY_RECEIVED', label: '部分入庫' },
  { value: 'RECEIVED', label: '已入庫' },
  { value: 'CLOSED', label: '已結案' },
  { value: 'TERMINATED', label: '已中止' },
  { value: 'CANCELLED', label: '已取消' },
];

/** 寫死色票：深底淺字 */
export const PURCHASE_ORDER_STATUS_CLASS = {
  DRAFT: 'border-transparent bg-slate-600 text-slate-50',
  SUBMITTED: 'border-transparent bg-sky-600 text-sky-50',
  APPROVED: 'border-transparent bg-amber-600 text-amber-50',
  PARTIALLY_RECEIVED: 'border-transparent bg-violet-600 text-violet-50',
  RECEIVED: 'border-transparent bg-teal-600 text-teal-50',
  CLOSED: 'border-transparent bg-emerald-600 text-emerald-50',
  CANCELLED: 'border-transparent bg-rose-600 text-rose-50',
};

export function formatPurchaseOrderStatusLabel(status) {
  if (status == null || status === '') {
    return '-';
  }
  return PURCHASE_ORDER_STATUS_LABELS[status] ?? status;
}

/** 僅 DRAFT 可進 Create／Edit 全單編輯。 */
export function canEditPurchaseOrderDraft(status) {
  return status === PURCHASE_ORDER_STATUS.DRAFT;
}

export function canSubmitPurchaseOrder(status) {
  return status === PURCHASE_ORDER_STATUS.DRAFT;
}

/** 刪除草稿：DRAFT 實體刪除（be doc abbce90d；已有進貨或付款紀錄時後端拒絕）。 */
export function canCancelDraftPurchaseOrder(status) {
  return status === PURCHASE_ORDER_STATUS.DRAFT;
}

export function canApprovePurchaseOrder(status) {
  return status === PURCHASE_ORDER_STATUS.SUBMITTED;
}

export function canRejectPurchaseOrder(status) {
  return status === PURCHASE_ORDER_STATUS.SUBMITTED;
}

export function canClosePurchaseOrder(status) {
  return (
    status === PURCHASE_ORDER_STATUS.APPROVED
    || status === PURCHASE_ORDER_STATUS.PARTIALLY_RECEIVED
    || status === PURCHASE_ORDER_STATUS.RECEIVED
  );
}

/**
 * 尚有未完成的有效應交量（任一列 `qtySummary.openQty` > 0）。
 * 結案需全數入庫；中止僅限仍有未交量（全數入庫時後端回 409，應改結案）。
 */
export function hasOpenPurchaseOrderQty(lines) {
  return (lines ?? []).some((line) => Number(line?.qtySummary?.openQty ?? line?.openQty) > 0);
}

/** 中止（提前停止剩餘應交量）：APPROVED／PARTIALLY_RECEIVED／RECEIVED 且仍有未交量。 */
export function canTerminatePurchaseOrder(status, lines) {
  return canClosePurchaseOrder(status) && hasOpenPurchaseOrderQty(lines);
}

/** 異動（立即套用）：僅 APPROVED／PARTIALLY_RECEIVED／RECEIVED。 */
export function canAmendPurchaseOrder(status) {
  return canClosePurchaseOrder(status);
}

/** 結案按鈕是否顯示：狀態允許且至少一張關聯入庫單。 */
export function canShowClosePurchaseOrderAction(status, stockReceiptCount) {
  if (!canClosePurchaseOrder(status)) {
    return false;
  }
  return Number(stockReceiptCount) >= 1;
}

/** 直接建入庫（可不經排程）；僅 APPROVED／PARTIALLY_RECEIVED（定案 C：草稿不可）。 */
export function canCreateStockReceiptFromPurchaseOrder(status) {
  return (
    status === PURCHASE_ORDER_STATUS.APPROVED
    || status === PURCHASE_ORDER_STATUS.PARTIALLY_RECEIVED
  );
}

/**
 * 新建排程：DRAFT～RECEIVED 可；CLOSED／TERMINATED／CANCELLED 不可（定案 C：草稿可排程）。
 * （含 SUBMITTED／APPROVED／PARTIALLY_RECEIVED／RECEIVED）
 */
export function canCreateArrivalSchedule(status) {
  return (
    status != null
    && status !== ''
    && status !== PURCHASE_ORDER_STATUS.CLOSED
    && status !== PURCHASE_ORDER_STATUS.TERMINATED
    && status !== PURCHASE_ORDER_STATUS.CANCELLED
  );
}
